// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"1757":"3b544a9d33d5be87","8237":"18886201b0e19b6a","9528":"68a18abbb9e95e2a"}[chunkId] + ".css";
};